import { isMobile } from '../modules/utilities';

const TOAST_RIGHT_SECTION = 'toast-right';
const TOAST_MIDDLE_SECTION = 'toast-middle';

const TOAST_DURATION = 5000;

export const addToastMessage = ({ imgSrc, body, btnHref, btnText, btnCb, position = 'right' } = {}) => {
  const toastId = position === 'right' && !isMobile ? TOAST_RIGHT_SECTION : TOAST_MIDDLE_SECTION;
  const toastContainer = document.getElementById(toastId);
  if (toastContainer && (imgSrc || body || btnText)) {
    const toastItem = document.createElement('div');
    toastItem.classList.add('toast-item');
    if (imgSrc) {
      const imgEl = document.createElement('img');
      imgEl.classList.add('toast-img');
      imgEl.src = imgSrc;
      toastItem.appendChild(imgEl);
    }
    if (body) {
      const bodyEl = document.createElement('p');
      bodyEl.classList.add('toast-body');
      bodyEl.innerText = body;
      toastItem.appendChild(bodyEl);
    }
    if (btnText) {
      const btnEl = document.createElement('a');
      btnEl.classList.add('toast-btn');
      btnEl.innerText = btnText;
      if (!btnCb && btnHref) {
        btnEl.href = btnHref;
      }
      if (btnCb) {
        btnEl.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeToast();
          btnCb();
        });
      }
      toastItem.appendChild(btnEl);
    }
    toastContainer.appendChild(toastItem);
    requestAnimationFrame(() => {
      toastItem.classList.add('active');
    });
    const closeToast = () => {
      toastItem.classList.remove('active');
      toastItem.addEventListener('transitionend', () => {
        toastItem.remove();
      });
    }
    let timeout = setTimeout(() => {
      closeToast();
    }, TOAST_DURATION);
    toastItem.addEventListener('mouseover', () => {
      clearTimeout(timeout);
    });
    toastItem.addEventListener('mouseout', () => {
      timeout = setTimeout(() => {
        closeToast();
      }, TOAST_DURATION);
    });
  }
}

const initToast = () => {
  const leftToastEl = document.createElement('div');
  leftToastEl.setAttribute('id', TOAST_RIGHT_SECTION);
  leftToastEl.classList.add(TOAST_RIGHT_SECTION);
  leftToastEl.addEventListener('click', e => e.stopPropagation());
  document.body.appendChild(leftToastEl);
  const middleToastEl = document.createElement('div');
  middleToastEl.setAttribute('id', TOAST_MIDDLE_SECTION);
  middleToastEl.classList.add(TOAST_MIDDLE_SECTION);
  middleToastEl.addEventListener('click', e => e.stopPropagation());
  document.body.appendChild(middleToastEl);
}

document.addEventListener("DOMContentLoaded", initToast);



// WEBPACK FOOTER //
// ./src/js/components/toast.js